// src/api/marketingApi.js
import apiClient from './axios';

const marketingApi = {
  // 1. App Details
  getAppDetails: params => apiClient.get('/marketing/app-details', { params }).then(r => r.data),
  createAppDetail: data => apiClient.post('/marketing/app-details', data).then(r => r.data),
  updateAppDetail: (id, data) => apiClient.put(`/marketing/app-details/${id}`, data).then(r => r.data),
  deleteAppDetail: id => apiClient.delete(`/marketing/app-details/${id}`),

  // ── PRODUCTS ────────────────────────────────────────────────
  getProducts: (params) => 
    apiClient.get('/marketing/products', { params }).then(r => r.data),

  createProduct: (data) => 
    apiClient.post('/marketing/products', data).then(r => r.data),

  updateProduct: (id, data) => 
    apiClient.put(`/marketing/products/${id}`, data).then(r => r.data),

  deleteProduct: (id) => 
    apiClient.delete(`/marketing/products/${id}`),

   exportProducts: () => 
    apiClient.get('/marketing/products/export', { responseType: 'blob' })
      .then(r => r.data),

  importProductsPreview: (file) => {
    const form = new FormData();
    form.append('file', file);
    return apiClient.post('/marketing/products/import-preview', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then(r => r.data);
  },

  importProductsConfirm: async (preview) => {
    const response = await apiClient.post("/marketing/products/import", {
      preview,
    });
    return response.data;
  },


  // 2. Message Logs
  getMessageLogs: params => apiClient.get('/marketing/message-logs', { params }).then(r => r.data),
  
  getMessageLogById: id => apiClient.get(`/marketing/message-logs/${id}`).then(r => r.data),

  // Create / Send new message (multipart form-data)
  sendMessage: (formData) => {
    return apiClient.post('/marketing/send-message', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then(r => r.data);
  },

  updateMessageLogStatus: (id, data) => apiClient.post(`/marketing/message-logs/${id}/status`, data).then(r => r.data),

  deleteMultipleMessageLogs: ids => apiClient.post('/marketing/message-logs/delete-multiple', { log_ids: ids }).then(r => r.data),

  // 3. Other Contacts
  getOtherContacts: params => apiClient.get('/marketing/otherContact', { params }).then(r => r.data),
  createOtherContact: data => apiClient.post('/marketing/otherContact', data).then(r => r.data),
  updateOtherContact: (id, data) => apiClient.put(`/marketing/otherContact/${id}`, data).then(r => r.data),
  deleteOtherContact: id => apiClient.delete(`/marketing/otherContact/${id}`),

    exportOtherContacts: () => 
    apiClient.get('/marketing/other-contacts/export', { responseType: 'blob' })
      .then(r => r.data),

  importOtherContactsPreview: (file) => {
    const form = new FormData();
    form.append('file', file);
    return apiClient.post('/marketing/otherContact/import-preview', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then(r => r.data);
  },

  // importOtherContactsConfirm: (preview) => 
  //   apiClient.post('/marketing/otherContact/import', { preview })
  //     .then(r => r.data),

        importOtherContactsConfirm: async (preview) => {
    const response = await apiClient.post("/marketing/otherContact/import", {
      preview,
    });
    return response.data;
  },
      
  // 4. Campaigns
  getCampaigns: params => apiClient.get('/marketing/campaigns', { params }).then(r => r.data),
  createCampaign: data => apiClient.post('/marketing/campaigns', data).then(r => r.data),
  updateCampaign: (id, data) => apiClient.put(`/marketing/campaigns/${id}`, data).then(r => r.data),
  deleteCampaign: id => apiClient.delete(`/marketing/campaigns/${id}`),

  // 5. Contact Groups
  getContactGroups: params => apiClient.get('/marketing/contact-groups', { params }).then(r => r.data),
  createContactGroup: data => apiClient.post('/marketing/contact-groups', data).then(r => r.data),
  updateContactGroup: (id, data) => apiClient.put(`/marketing/contact-groups/${id}`, data).then(r => r.data),
  deleteContactGroup: id => apiClient.delete(`/marketing/contact-groups/${id}`),

  // 6. Demo Schedules
  getDemoSchedules: params => apiClient.get('/marketing/demo-schedules', { params }).then(r => r.data),
  createDemoSchedule: data => apiClient.post('/marketing/demo-schedules', data).then(r => r.data),
  updateDemoSchedule: (id, data) => apiClient.put(`/marketing/demo-schedules/${id}`, data).then(r => r.data),
  deleteDemoSchedule: id => apiClient.delete(`/marketing/demo-schedules/${id}`),

  // 7. Categories
  getCategories: params => apiClient.get('/marketing/categories', { params }).then(r => r.data),
  createCategory: data => apiClient.post('/marketing/categories', data).then(r => r.data),
  updateCategory: (id, data) => apiClient.put(`/marketing/categories/${id}`, data).then(r => r.data),
  deleteCategory: id => apiClient.delete(`/marketing/categories/${id}`),

  // 8. Dashboard
  getDashboardSummary: () => apiClient.get('/marketing/dashboard/summary').then(r => r.data),


  // ── LEAD STATUSES ────────────────────────────────────────────────
getLeadStatuses: (params) => 
  apiClient.get('/marketing/lead-statuses', { params }).then(r => r.data),

createLeadStatus: (data) => 
  apiClient.post('/marketing/lead-statuses', data).then(r => r.data),

updateLeadStatus: (id, data) => 
  apiClient.put(`/marketing/lead-statuses/${id}`, data).then(r => r.data),

deleteLeadStatus: (id) => 
  apiClient.delete(`/marketing/lead-statuses/${id}`),


// ── LEADS ────────────────────────────────────────────────────────────────
getLeads: (params) => 
  apiClient.get('/marketing/leads', { params }).then(r => r.data),

addContactFromLead: (leadId, data = {}) => 
  apiClient.post(`/marketing/leads/${leadId}/add-contact`, data)
    .then(r => r.data),

createLead: (data) => 
  apiClient.post('/marketing/leads', data).then(r => r.data),

updateLead: (id, data) => 
  apiClient.post(`/marketing/leads/${id}`, data).then(r => r.data),

deleteLead: (id) => 
  apiClient.delete(`/marketing/leads/${id}`),

getLeadShareHistory: (leadId) => 
  apiClient.get(`/marketing/leads/${leadId}/share-history?page_size=all`)
    .then(r => r.data),

    getLeadStatusHistory: (leadId) => 
  apiClient.get(`/marketing/leads/${leadId}/status-history`, {
    params: { page_size: 'all' } // or remove if backend handles no pagination
  }).then(r => r.data),
    
  // ── LEADS IMPORT/EXPORT ─────────────────────────────────────
exportLeads: () => 
  apiClient.get('/marketing/leads/export/csv', { responseType: 'blob' })
    .then(r => r.data),

importLeadsPreview: (file) => {
  const form = new FormData();
  form.append('file', file);
  return apiClient.post('/marketing/leads/import-preview', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then(r => r.data);
},

// importLeadsConfirm: (preview) => 
//   apiClient.post('/marketing/leads/import', { preview })
//     .then(r => r.data),


           importLeadsConfirm: async (preview) => {
    const response = await apiClient.post("/marketing/leads/import", {
      preview,
    });
    return response.data;
  },

};

export default marketingApi;